import Swal from 'sweetalert2';
import { get_token } from "@/router";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';

export default {
mounted() {
  this.getProfileTypes();
  this.preview();
  this.get_question_types();
  this.fetchQuestions().then(() => {
      this.$nextTick(() => {
        $('.questionsTable').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
},
  data: () => ({
    questionDetails: [],
    token_exists: false,
    selectedQuestions: [],
  }),
  watch: {
    '$route.params.sections_id'() {
      this.assign_question();
    }
  },
  components: {
    Sidebar,
    Navbar,
  },

  methods: {
    getToken() {
      return get_token();
    },

    getProfileTypes() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.profileTypes = response.data;
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load profile types",
          });
        }
      });
    },

    preview() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
        method: "POST",
        headers: this.token_exists
          ? { Authorization: `Token ${this.getToken()}` }
          : {},
        success: (response) => {
          const questionDetails = response.data.questions.map(question => ({
            question_id: question.id,
            question_name: question.question,
            question_type: question.question_type.question_type
          }));
          
          this.questionDetails = questionDetails;
          this.$nextTick(() => {
            if (this.dataTableInstance) {
              this.dataTableInstance.destroy();
            }
            this.dataTableInstance = $("#questionsTable").DataTable();
          });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load question types",
          });
        }
      });
    },

get_question_types() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.question_types = response.data.question_types;
        },
        error: () => {
          Swal.fire({
            icon: "error",
           title: "Failed to load question types",
          });
        }
      });
    },
     assign_question() 
     {
      const section_id = this.$route.params.section_id;
      const payload={'question_ids': this.selectedQuestions,
      'section_id': section_id}

      
  
      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/assign_questions/`,
          method: "POST",
          headers: { 
            Authorization: `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
         },
          data: JSON.stringify(payload),
          processData: false,
          success: (response) => {
          if (response.status === "success") {
              Swal.fire({
                  icon: "success",
                  title: "Questions submitted",
                  text: "All questions have been submitted",
                  showConfirmButton: false,
                  timer: 2000
              });
          }
          }
      });
  },

    fetchQuestions() {
      this.token_exists = get_token();
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`
          },
          success: (response) => {
            this.questions = response.data.questions;
            resolve();
          },
        });
      });
    }
  }
};

